import { Navigate, useLocation } from "react-router-dom";

import Layout from "@/Layout";
import { LayoutProvider } from "@/context/LayoutContext";
import React from "react";
import { useSelector } from "react-redux";

function ProtectedRouter() {
  const { isAuthenticated, allAllowedRoutes } = useSelector(
    (state) => state.authReducer
  );
  const location = useLocation();

  const isRouteAllowed = (pathname) => {
    if (allAllowedRoutes === undefined || allAllowedRoutes.length === 0) {
      return true;
    } else {
      return allAllowedRoutes.some((allowedPath) => {
        const pattern = new RegExp(`^${allowedPath}(\\/.*)?$`);
        return pattern.test(pathname);
      });
    }
  };

  return (
    <>
      {isAuthenticated && isRouteAllowed(location?.pathname) ? (
        <LayoutProvider>
          <Layout />
        </LayoutProvider>
      ) : (
        <Navigate replace to="/" />
      )}
    </>
  );
}
export default ProtectedRouter;
